// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"1b05f923","488":"ad382535","591":"27f40e34"}[chunkId] + ".chunk.js";
};